import { CommonContentWrapper } from "../../common/components/content_wrapper/CommonContentWrapper";
import { Padding, Row, SizedBox } from "../../common/components/CommonBaseComponents";
import { PageTitle } from "../../common/components/PageTitle";
import CustomPeriodButton from "../../common/components/button/CustomPeriodButton";
import { useState } from "react";
import CustomTab from "../../common/components/tab/CustomTab";
import { useSearchParams } from "react-router-dom";
import StatisticalAnalysisRevenueTabContent from "./tabs/StatisticalAnalysisRevenueTabContent";
import StatisticalAnalysisUsageTabContent from "./tabs/StatisticalAnalysisUsageTabContent";
import SecondaryButton from "../../common/components/button/SecondaryButton";
import Translate from "../../common/translate/Translate";
import { useDevice } from "../../common/hooks/useDevice";

const tabs = [
    { value: "Revenue", label: Translate("revenue.revenue") },
    { value: "Usage", label: Translate("revenue.usage") },
];

export function StatisticalAnalysisPage() {
    const [searchParams, setSearchParams] = useSearchParams();
    const activeTab = searchParams.get("tab") || "Revenue";

    const handleSetTab = (tabValue) => {
        setSearchParams({ tab: tabValue }, { replace: true });
    };

    const [dateRange, setDateRange] = useState("7days");

    const currentDevice = useDevice();

    return (
        <CommonContentWrapper>
            <Padding padding={"24px 20px"}>
                <PageTitle title={Translate("gnb.statisticalAnalysis")} />
                <Padding padding={"24px 12px"}>
                    <Row width={"100%"} justifyContent={"space-between"}>
                        <CustomTab tabs={tabs} activeTab={activeTab} onClick={handleSetTab} />
                        <Row>
                            <CustomPeriodButton
                                currentValue={dateRange}
                                setValue={setDateRange}
                                values={[
                                    { value: "7days", label: Translate("common.days", ["7"]) },
                                    { value: "30days", label: Translate("common.days", ["30"]) },
                                ]}
                                hasCustom={true}
                                openedCalendarLeftSide={true}
                            />
                            <SizedBox width={"10px"} />
                            {currentDevice === "desktop" && (
                                <SecondaryButton icon={"download"} text={Translate("common.exportExcel")} />
                            )}
                        </Row>
                    </Row>
                </Padding>
                {activeTab === "Revenue" && <StatisticalAnalysisRevenueTabContent dateRange={dateRange} />}
                {activeTab === "Usage" && <StatisticalAnalysisUsageTabContent dateRange={dateRange} />}
            </Padding>
        </CommonContentWrapper>
    );
}
